<template>
  <div class="admin-edit-keyword px-2 px-md-4 py-2 py-md-4">
    <AdminKeywordDetail
      :keywordId="$route.params.keywordId"
      @updated="goBackToList"
      @deleted="goBackToList"
    />
  </div>
</template>

<script>
/* eslint-disable */
import AdminKeywordDetail from './AdminKeywordDetail.vue';

export default {
  name: 'AdminEditKeyword',
  components: { AdminKeywordDetail },
  methods: {
    goBackToList() {
      this.$router.push({ path: "/admin/keywords" }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.admin-edit-keyword {
  width: 100%;
  height: 100%;
}
</style>